import React, { useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { READER_BASE_URL } from "../config.js";
import TokenService from "../services/auth/TokenService";

const AuthoringToolTwoPointZero = () => {
  const iframeRef = useRef(null);
  const location = useLocation(); // Hook to access location object

  // Function to get query parameters from the current location
  const getQueryParams = () => {
    const params = new URLSearchParams(location.search); // Extract query params from URL
    const bookParam = params.get("book"); // Get the 'book' query parameter
    return { book: bookParam };
  };

  // Function to update the iframe src
  const updateIframeSrc = () => {
    const { book } = getQueryParams(); // Retrieve the bookId from the query params
    const token = btoa(JSON.stringify(TokenService.getUser())); // Get the user token

    // Construct the iframe source URL with conditional book parameter
    const iframeSrc = `${READER_BASE_URL}/?mode=authoring&token=${token}${
      book ? `&book=${encodeURIComponent(book)}` : "" // Check if book is truthy and encode it
    }`;

    // Update the iframe's source only if it has changed
    if (iframeRef.current.src !== iframeSrc) {
      iframeRef.current.src = iframeSrc;
    }
  };

  // Update the iframe src when query parameters change
  useEffect(() => {
    updateIframeSrc(); // Update iframe whenever location.search changes
  }, [location.search]); // Depend on location.search to update when URL changes

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        height: "100svh",
        backgroundColor: "black",
        color: "white",
        width: "100svw",
        overflow: "hidden",
      }}
    >
      <iframe
        ref={iframeRef}
        id="reader-iframe"
        title="Authoring Tool 2.0"
        allow="clipboard-read *; clipboard-write *"
        style={{
          position: "fixed",

          top: 48,
          left: 0,
          height: "calc(100% - 48px)",
          width: "100%",
        }}
      />
    </div>
  );
};

export default AuthoringToolTwoPointZero;
